module.exports = __webpack_public_path__ + "img/4.32c0d0e3.webp";